import * as React from 'react';
import { ProspectUserPreference } from '../../../../../api/ProspectUserProfile';
import { AdditionalResident } from '../../../../../api/Prospect';
import { formatPhoneNumber } from '../../../../../utilities/Utils';
import { relationshipTypeDisplay } from '../../../../../utilities/formatting';
import * as moment from 'moment';

const AdditionalResidentDisplay = (props: { resident: AdditionalResident }) => (
    <span>
        <br />
        <b>{relationshipTypeDisplay(props.resident.relationshipType)}:</b>{' '}
        {props.resident.firstName} {props.resident.lastName},{' '}
        {formatPhoneNumber(props.resident.phone)}, {props.resident.email}
    </span>
);

interface Props {
    preferences: ProspectUserPreference;
    unitTypeDescription: string;
}

const ProspectPreferenceDisplay = (props: Props) => (
    <div>
        {props.unitTypeDescription}

        {props.preferences.desiredMoveInDate && (
            <div>Move in {moment(props.preferences.desiredMoveInDate).format('MM-DD-YYYY')}</div>
        )}

        {props.preferences.pet === true && <div>Pet: yes</div>}
        {props.preferences.pet === false && <div>Pet: no</div>}
        {props.preferences.additionalResidents.map((ar, index) => (
            <AdditionalResidentDisplay key={index} resident={ar} />
        ))}
    </div>
);

export default ProspectPreferenceDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/display/ProspectPreferenceDisplay.tsx